import * as React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';

import { AudiFeatureAppTyreLabelTyreLabelItem } from './TyreLabel';
import { TyreLabelImageStyled, TyreLabelItemStyled } from './styles';

interface TyreLabelItemProps {
  tyreLabelItem: AudiFeatureAppTyreLabelTyreLabelItem;
}

export const TyreLabelItem: React.FC<TyreLabelItemProps> = ({ tyreLabelItem }) => {
  const ImageAltText = useI18n({ id: 'fa.audi-feature-app-tyre-label.tyre-label-image-alt-text' });
  const pdfLabel = useI18n({ id: 'fa.audi-feature-app-tyre-label.tyre-label-pdf-link' });

  return (
    <>
      <TyreLabelItemStyled>
        <TyreLabelImageStyled src={tyreLabelItem.tyreLabelUrl} alt={ImageAltText} />
        <TextButton
          variant="tertiary"
          href={tyreLabelItem.productSheetUrl}
          icon="documents"
          iconPosition="leading"
          target="_blank"
          rel="noopener"
          size="sm"
        >
          {pdfLabel}
        </TextButton>
      </TyreLabelItemStyled>
    </>
  );
};
